import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ConceptSection from './components/ConceptSection';
import InformationSection from './components/InformationSection';
import StyleSection from './components/StyleSection';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';
import { updatePageSEO, getSiteUrl } from '../../utils/seo';

export default function HomePage() {
  useEffect(() => {
    const siteUrl = getSiteUrl();
    updatePageSEO({
      title: '岡山市の美容室おかやま美容室 | カット・カラー・パーマ・トリートメント',
      description: '岡山市北区の美容室おかやま美容室。丁寧なカウンセリングと確かな技術で理想のヘアスタイルを実現。カット、カラー、パーマ、トリートメント、ヘッドスパなど幅広いメニューをご用意。岡山市で信頼される美容室として、お客様一人ひとりの魅力を引き出します。営業時間9:00-18:00、定休日は日曜日・祝日。',
      keywords: '岡山市 美容室, 岡山 ヘアサロン, 岡山市北区 美容室, カット, カラー, パーマ, トリートメント, ヘアケア, おかやま美容室',
      canonical: `${siteUrl}/`,
      ogTitle: '岡山市の美容室おかやま美容室 | カット・カラー・パーマ・トリートメント',
      ogDescription: '岡山市北区の美容室おかやま美容室。丁寧なカウンセリングと確かな技術で理想のヘアスタイルを実現。',
      ogType: 'website',
      ogUrl: `${siteUrl}/`,
      ogImage: 'https://public.readdy.ai/ai/img_res/670fe62545c05471b8b29c74da11c620.jpg',
      jsonLd: {
        '@context': 'https://schema.org',
        '@type': 'HairSalon',
        name: 'おかやま美容室株式会社',
        image: 'https://readdy.ai/api/search-image?query=modern-japanese-hair-salon-okayama&width=1200&height=630&seq=og001&orientation=landscape',
        address: {
          '@type': 'PostalAddress',
          streetAddress: '○○町1-2-3',
          addressLocality: '岡山市北区',
          addressRegion: '岡山県',
          postalCode: '700-0000',
          addressCountry: 'JP',
        },
        geo: {
          '@type': 'GeoCoordinates',
          latitude: 34.66167,
          longitude: 133.91833,
        },
        url: siteUrl,
        telephone: '+81-86-012-3456',
        faxNumber: '+81-86-012-3457',
        openingHoursSpecification: {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
          opens: '09:00',
          closes: '18:00',
        },
        priceRange: '¥¥',
        description: '岡山市北区の美容室おかやま美容室。丁寧なカウンセリングと確かな技術で理想のヘアスタイルを実現。カット、カラー、パーマ、トリートメント、ヘッドスパなど幅広いメニューをご用意。',
        founder: {
          '@type': 'Person',
          name: '岡山 太郎',
        },
        foundingDate: '2000',
        numberOfEmployees: 5,
      },
    });
  }, []);

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <ConceptSection />
        <InformationSection />
        <StyleSection />
        <TestimonialSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
